module.exports = __webpack_public_path__ + "img/image.cafe92d7.png";